module.exports = __webpack_public_path__ + "img/Weapon_261.1f96d56b.png";